import { clsx } from 'clsx'
import Image from 'next/image'
import { memo, useMemo } from 'react'

interface IProps {
	className?: string
}

const ZSuspenseLoading: React.FC<IProps> = ({ className }) => {
	const containerClassName = useMemo(
		() => clsx('min-h-[25vh] w-full opacity-50 flex items-center justify-center', className),
		[className]
	)

	return (
		<div
			className={containerClassName}
			role='status'
			aria-live='polite'
			aria-label='Načítavam...'
		>
			<div className='wrapper flex items-center justify-center'>
				<Image
					unoptimized={true}
					src='/assets/images/medante-logo-dark.svg'
					alt='Medante'
					width={431}
					height={115}
					className='animate-pulse duration-1500 h-8 w-auto'
				/>
			</div>
		</div>
	)
}

export default memo(ZSuspenseLoading)
